import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/storage';
import format from 'date-fns/format'
import addMonths from 'date-fns/add_months';
import addYears from 'date-fns/add_years';
import subMonths from 'date-fns/sub_months'
import _ from 'lodash'
import CryptoJS from 'crypto-js'
import axios from 'axios';
import { getByUser, getCompany,getUserAll } from './core/cacheService'
import {
  applyRewardViewFilters,
  buildCatalogCountriesFromRaw,
  getNewRewardKeysForTab,
  processRewardsFromCatalog,
} from '@/utils/rewardCatalog'
import { getRewardActivityLoadMode } from '@/utils/rewardActivity'
import {
  buildLinkedGemVariant,
  findLinkedGemVariant,
  getMasterRewardId,
  validateLinkedGemVariant,
} from '@/utils/rewardVariants'

let redeemActivityRequest: Promise<any> | null = null
let rewardsFetchPromise: Promise<any> | null = null

function sanitizeRewardFilename(filename: string | null | undefined): string {
  if (!filename || typeof filename !== 'string') {
    return `reward_image_${Date.now()}.jpg`
  }

  const trimmed = filename.trim()
  const lastDot = trimmed.lastIndexOf('.')
  const hasExt = lastDot > 0 && lastDot < trimmed.length - 1
  const rawExt = hasExt ? trimmed.slice(lastDot + 1) : ''
  const rawBase = hasExt ? trimmed.slice(0, lastDot) : trimmed
  const ext = rawExt.toLowerCase().replace(/[^a-z0-9]/g, '') || 'jpg'
  const base = rawBase
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9_-]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')

  return `${base || `reward_image_${Date.now()}`}.${ext}`
}

function hasCachedRewardCatalog(state: any) {
  return !!(state.rewards_catalog_raw && Object.keys(state.rewards_catalog_raw).length > 0)
}

function syncRewardCatalogCommits(commit: any, catalogRaw: any) {
  const catalog = catalogRaw || {}
  commit('setRewardsCatalogRaw', catalog)
  commit('setRewardsall_company', catalog)
}

function finalizeRewardView({ commit, state }: any, processed: any) {
  const { rewardsSorted, countnewreward, newReward, counts } = processed
  const filtered = applyRewardViewFilters(rewardsSorted, state.inputSearch, state.selectShow)

  commit('setNewReword', newReward)
  commit('setrewardsAll', rewardsSorted)
  commit('setcountNewReward', countnewreward)
  commit('setcountRewards', counts)
  commit('setrewards', filtered)
  commit('setrewardsSearch', filtered)
}

export default {
  namespaced: true,
  state: {
    rewards: [],
    rewardsemptytext: 'No Rewards',
    showTextLoading: 'Loading...',
    rewardsSearch: [],
    rewardsAll: [],
    inputSearch: '',
    selectShow: '',
    tabs: '0',
    countrewards: [],
    redeemed: [],
    membersall:[],
    rewardsall_db:[],
    rewardsall_db_loaded: false,
    rewardsall_company:[],
    rewards_catalog_raw: {},
    list_month:[],
    cerrent_month:'',
    start_month:'',
    loadmore:false,
    loadmore_lock:false,
    lastDate:'',
    engonly:true,
    checkengonly:false,
    rewardMessageData: [],
    processingRedeemed:0,
    country:[],
    memberCountries:[],
    catalogCountries:[],
    selectedCountryFilter: 'all',
    tagMaster:{},
    rewardsMaster:{},
    rewardsMasterData:{},
    redeemAll:{},
    redeemActivityLoadedAt: 0,
    rewardActivityLoading: false,
    rewardActivityRefreshing: false,
    rewardActivityError: '',
    dataChart:[],
    companySymbol: '฿',
    allSymbol: [],
    language:[],
    countNewReward:{},
    newReward:[],
    gemExchangeConfig: null
  },
  mutations: {
    setrewards(state: any, result: any) {
      if(result.length>0){
        state.rewardsemptytext = 'Loading...'
      }else{
        state.rewardsemptytext = 'No Rewards'
      }
      state.rewards = result
    },
    setrewardsSearch(state: any, result: any) {
      state.rewardssearch = result
    },
    setrewardsAll(state: any, result: any) {
      state.rewardsall = result
    },
    setinputSearch(state: any, value: any) {
      state.inputSearch = value.value
    },
    setselectShow(state: any, value: any) {
      state.selectShow = value.type
    },
    setTab(state: any, value: any) {
      state.tabs = value
    },
    setcountRewards(state: any, value: any) {
      state.countrewards = value
    },
    setredeemed(state: any, result: any) {
      if(result.length>0){
        state.showTextLoading = 'Loading...'
      }else{
        state.showTextLoading = 'No records found'
      }
      state.redeemed = result
    },
    setShowTextLoading(state: any, result: any) {
      state.showTextLoading = result
    },
    setMemberall(state:any, result:any) {
      state.membersall = result
    },
    setRewardsall_db(state:any, result:any) {
      state.rewardsall_db = result
      state.rewardsall_db_loaded = true
    },
    setRewardsall_company(state:any, result:any) {
      state.rewardsall_company = result
    },
    setRewardsCatalogRaw(state:any, result:any) {
      state.rewards_catalog_raw = result || {}
    },
    setCerrentmonth(state:any, result:any) {
      state.cerrent_month = result
    },
    setList_month(state:any, result:any) {
      state.list_month = result
    },
    setStartmonth(state:any, result:any) {
      state.start_month = result
    },
    setLoadmore(state:any, result:any) {
      state.loadmore = result
    },
    setlastDate(state:any, result:any) {
      state.lastDate = result
    },
    setloadmoreLock(state:any, result:any) {
      state.loadmore_lock = result
    },
    setEngOnly(state:any, result:boolean) {
      state.engonly = result
    },
    setCheckEngOnly(state:any, result:boolean) {
      state.checkengonly = result
    },
    setRewardMessageData(state:any, result:any) {
      state.rewardMessageData = result
    },
    setProcessingRedeemed(state:any, result:any) {
      state.processingRedeemed = result
    },
    setCountry(state:any, result:any) {
      state.country = result
    },
    setMemberCountries(state:any, result:any) {
      state.memberCountries = result
    },
    setCatalogCountries(state:any, result:any) {
      state.catalogCountries = result
    },
    setSelectedCountryFilter(state:any, result:any) {
      state.selectedCountryFilter = result
    },
    setTagMaster(state:any, result:any) {
      state.tagMaster = result
    },
    setRewardsMaster(state:any, result:any) {
      state.rewardsMaster = result
    },
    setRewardsMasterData(state:any, result:any) {
      state.rewardsMasterData = result
    },
    setRedeemAll(state:any, result:any) {
      state.redeemAll = result
    },
    setRedeemActivityLoadedAt(state:any, result:any) {
      state.redeemActivityLoadedAt = result
    },
    setRewardActivityLoading(state:any, result:boolean) {
      state.rewardActivityLoading = result
    },
    setRewardActivityRefreshing(state:any, result:boolean) {
      state.rewardActivityRefreshing = result
    },
    setRewardActivityError(state:any, result:any) {
      state.rewardActivityError = result || ''
    },
    setDataChart(state:any, result:any) {
      state.dataChart = result
    },
    setCompanySymbol(state:any, result:any) {
      state.companySymbol = result
    },
    setAllSymbol(state:any, result:any) {
      state.allSymbol = result
    },
    setlanguage(state:any, result:any){
      state.language = result
    },
    setcountNewReward(state:any, result:any){
      state.countNewReward = result
    },
    setNewReword(state:any, result:any){
      state.newReward = result
    },
    setGemExchangeConfig(state:any, result:any){
      state.gemExchangeConfig = result
    },
    updateRedeemedStatus(state:any, payload:any) {
      state.redeemed.forEach((item:any) => {
        if(item && item.id === payload.id){
          item.status = payload.status
        }
      })

      Object.keys(state.redeemAll || {}).forEach((monthKey) => {
        const monthData = state.redeemAll[monthKey]
        if(!Array.isArray(monthData)){
          return
        }

        monthData.forEach((item:any) => {
          if(item && item.id === payload.id){
            item.status = payload.status
          }
        })
      })

      state.redeemActivityLoadedAt = 0
    }
  },
  actions: {
      async checkEngOnly({ commit, rootState, state, dispatch }: any){
        const LANG_FALLBACK:any = {
          'th': 'Thai',
          'ms': 'Bahasa Malaysia',
          'zh-HK': 'Chinese (Traditional, Hong Kong)',
          'pt-br': 'Brazilian Portuguese',
          'my': 'Burmese'
        }
        let language: { code: string; text: string }[] = [{code:"en",text:"English"}]
        if(state.checkengonly === false){
          var BreakException = {};
          const materlanguage=(await firebase.database().ref(`/language`).once('value')).val()
          // await dispatch('main/removeUser',true,{root:true})
          const lang =_.groupBy(rootState.main.allUser, function (b) {
            return b.language;
          });
          for(const i in lang){
              let text=materlanguage[i]?materlanguage[i].name.toString():(LANG_FALLBACK[i]||'')
              if(i!='en' && i!='undefined' && text){
                language.push({code:i,text:text})
              }
              
          } 
          commit('setlanguage',language)
          for(const data in rootState.main.allUser){
            try {
              
              if( rootState.main.allUser[data].language !== undefined &&  rootState.main.allUser[data].language === 'th') {
                  commit('setEngOnly',false)
                  commit('setCheckEngOnly',true)
                  throw BreakException;
                }
            } catch (e) {
              if (e !== BreakException) throw e;
            }
          }
          // firebase.database().ref(`users`).orderByChild("company").equalTo(rootState.authen.user.company).once('value', snapshot => {
          //   var BreakException = {};
          //   try {
          //     snapshot.forEach((data):any => {
          //       if(data.val().language !== undefined && data.val().language === 'th') {
          //         commit('setEngOnly',false)
          //         commit('setCheckEngOnly',true)
          //         throw BreakException;
          //       }
          //     });
          //   } catch (e) {
          //     if (e !== BreakException) throw e;
          //   }
          // });
        }
      },
      async getCountry({ commit, rootState, state, dispatch }: any){
        try {
          // Check if allUser data is empty and load it if necessary
          if (!rootState.main.allUser || Object.keys(rootState.main.allUser).length === 0) {
            try {
              // Load user data if not already loaded
              await dispatch('main/getuser', false, { root: true });
            } catch (error) {
              console.error('Failed to load user data for country filtering:', error);
              // Continue with empty country list rather than failing completely
            }
          }
          
          const { getCode, getName } = require('country-list');
          var country: Array<any> = [];
          var _country: Array<any> = [];
          var option_country: Array<any> = [];
          
          // Safely extract countries from user data
          if (rootState.main.allUser && typeof rootState.main.allUser === 'object') {
            for(const data in rootState.main.allUser){
              try {
                const user = rootState.main.allUser[data];
                if(user && user.country && typeof user.country === 'string' && user.country.trim() !== '') {
                  country.push(user.country.trim());
                }
              } catch (e) {
                console.warn('Error processing user country data:', e);
                continue;
              }
            }
          }
          
          // Get unique countries and validate them
          _country = _.uniq(country.filter(c => c && c.length > 0));
          
          _country.forEach(value => {
            try {
              if (value && typeof value === 'string') {
                const countryName = getName(value.toUpperCase());
                if (countryName) {
                  // Store as uppercase 2-letter code for consistency
                  option_country.push({label: countryName, value: value.toUpperCase()});
                }
              }
            } catch (error) {
              console.warn(`Invalid country code: ${value}`, error);
            }
          });

          commit('setCountry', option_country);
          commit('setMemberCountries', option_country);

          // Catalog countries are derived when getRewards caches the company catalog.
          if (hasCachedRewardCatalog(state)) {
            commit('setCatalogCountries', buildCatalogCountriesFromRaw(state.rewards_catalog_raw))
          }

          // Handle company billing currency with fallbacks
          try {
            const cmpOpt = await getCompany(rootState.authen.user.company)//(await firebase.database().ref(`company/${rootState.authen.user.company}`).once('value')).val();
            let currency = 'THB';
            let companySymbol = '฿';
            
            if (cmpOpt && cmpOpt.billing_currency && typeof cmpOpt.billing_currency === 'string') {
              currency = cmpOpt.billing_currency;
            }
            
            const allSymbolByKey = (await firebase.database().ref('currency').once('value')).val();
            let allSymbol: Array<any> = [];
            
            if (allSymbolByKey && typeof allSymbolByKey === 'object' && Object.keys(allSymbolByKey).length > 0) {
              const currencyData: any = _.find(allSymbolByKey, { currency: currency });
              companySymbol = (currencyData && currencyData.symbol && typeof currencyData.symbol === 'string') ? currencyData.symbol : '฿';
              
              _.forEach(allSymbolByKey, (item, key) => {
                if (item && item.currency && item.symbol) {
                  allSymbol[item.currency] = item.symbol;
                }
              });
              
              commit('setAllSymbol', allSymbol);
            }
            
            commit('setCompanySymbol', companySymbol);
          } catch (error) {
            console.error('Error loading company currency settings:', error);
            // Set defaults if currency loading fails
            commit('setCompanySymbol', '฿');
            commit('setAllSymbol', []);
          }
        } catch (error) {
          console.error('Critical error in getCountry action:', error);
          // Ensure we always set some default state
          commit('setCountry', []);
          commit('setCompanySymbol', '฿');
          commit('setAllSymbol', []);
        }
      },
      blockReward({ commit, rootState, dispatch }: any, reward: any) {
        let status = 'Y'
        if (!reward.block_status) {
          status = 'N';
        }
        //console.log(reward);
        firebase.database().ref(`rewards_company/${rootState.authen.user.company}/${reward.key}`).update({ status }).then(() => {
          /*save logs*/
          dispatch('authen/addLogs', {
            company: rootState.authen.user.company,
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            id: reward.key,
            table: 'rewards_company',
            status: 'activate',
            user: rootState.authen.user.email
          }, {root:true}).then(function() {
            dispatch('patchRewardInCatalog', { key: reward.key, partial: { status } })
          });
        });
    },
    async getTagMaster({ commit, dispatch, state }: any, user: any) {
      const tagMaster: Array<any> = [];
      await firebase.database().ref(`rewards_tag`).once('value', snapshot => {
        snapshot.forEach((doc): any => {
          if(doc.key) {
            tagMaster[doc.key]=doc.val()
          }
        });
        commit('setTagMaster', tagMaster)
      }).catch(error => {
        console.error('Error loading tag master data:', error)
      });
    },
    async getRewardsMaster({ commit, dispatch, state }: any, user: any) {
      
      const rewardsMaster: Array<any> = [];
      const rewardsMasterData: Array<any> = [];
      await firebase.database().ref(`rewards`).orderByChild("company").equalTo('global').once('value', snapshot => {
        snapshot.forEach((doc): any => {
          if(doc.key) {
            let endon=''
                if(doc.val().endon){
                  const day=doc.val().endon.split("/")[0]
                  const month=doc.val().endon.split("/")[1]
                  let year=doc.val().endon.split("/")[2]
                  year=year.slice(0,4)
                  endon=year+'-'+month+'-'+day

                }
            if(format(new Date(endon),"YYYY-MM-DD")>=format(new Date(),"YYYY-MM-DD")){
              
              
              rewardsMaster[doc.key]=doc.val().status
              rewardsMasterData[doc.key] = doc.val()

              if(rewardsMasterData[doc.key].rewards){
                rewardsMasterData[doc.key].names=rewardsMasterData[doc.key].rewards
              }else{
                rewardsMasterData[doc.key].names={en:rewardsMasterData[doc.key].reward_en,th:rewardsMasterData[doc.key].reward}
              }
              if(rewardsMasterData[doc.key].descriptions){
                rewardsMasterData[doc.key].descriptions=rewardsMasterData[doc.key].descriptions
              }else{
                rewardsMasterData[doc.key].descriptions={en:rewardsMasterData[doc.key].description_en,th:rewardsMasterData[doc.key].description}
              }
              
            }
            
          }
        });
        commit('setRewardsMaster', rewardsMaster)
        commit('setRewardsMasterData', rewardsMasterData)
      }).catch(error => {
        console.error('Error loading rewards master data:', error)
      });
    },
    async getRewards({ commit, dispatch, state, rootState }: any, user: any) {
      if (rewardsFetchPromise) {
        return rewardsFetchPromise
      }

      rewardsFetchPromise = (async () => {
        try {
          if (!user || !user.company) {
            console.error('Invalid user data provided to getRewards');
            commit('setrewards', []);
            return;
          }

          if (!state.country || state.country.length === 0) {
            try {
              await dispatch('getCountry');
            } catch (error) {
              console.error('Failed to load country data for reward filtering:', error);
            }
          }

          if (!state.rewardsall_db_loaded) {
            try {
              await dispatch('getAllrewards_db', user);
            } catch (error) {
              console.error('Failed to load master rewards data:', error);
            }
          }

          const snapshot = await firebase.database().ref(`rewards_company/${user.company}`).once('value')
          if (!snapshot.exists()) {
            console.warn(`No rewards found for company: ${user.company}`);
            syncRewardCatalogCommits(commit, {})
            commit('setrewards', []);
            commit('setrewardsSearch', []);
            commit('setrewardsAll', []);
            commit('setcountNewReward', { gift_cards: 0, perks: 0, team_building: 0, doing_good: 0, all: 0 });
            commit('setcountRewards', { Y: 0, N: 0, all: 0 });
            commit('setCatalogCountries', []);
            return;
          }

          const catalogRaw = snapshot.val() || {}
          syncRewardCatalogCommits(commit, catalogRaw)
          commit('setCatalogCountries', buildCatalogCountriesFromRaw(catalogRaw))
          finalizeRewardView({ commit, state }, processRewardsFromCatalog(catalogRaw, state))
        } catch (error) {
          console.error('Critical error in getRewards action:', error);
          commit('setrewards', []);
          commit('setrewardsSearch', []);
          commit('setrewardsAll', []);
          commit('setcountNewReward', { gift_cards: 0, perks: 0, team_building: 0, doing_good: 0, all: 0 });
          commit('setcountRewards', { Y: 0, N: 0, all: 0 });
        }
      })().finally(() => {
        rewardsFetchPromise = null
      })

      return rewardsFetchPromise
    },
    reprocessRewardsFromCache({ commit, dispatch, state, rootState }: any) {
      if (!hasCachedRewardCatalog(state)) {
        return dispatch('getRewards', rootState.authen.user)
      }

      finalizeRewardView({ commit, state }, processRewardsFromCatalog(state.rewards_catalog_raw, state))
      return Promise.resolve(true)
    },
    applyRewardFilters({ commit, dispatch, state, rootState }: any) {
      if (!hasCachedRewardCatalog(state)) {
        return dispatch('getRewards', rootState.authen.user)
      }

      return dispatch('reprocessRewardsFromCache')
    },
    patchRewardInCatalog({ commit, dispatch, state }: any, payload: { key: string, partial: any }) {
      if (!payload || !payload.key) {
        return Promise.resolve(false)
      }

      const catalogRaw = { ...(state.rewards_catalog_raw || {}) }
      catalogRaw[payload.key] = { ...(catalogRaw[payload.key] || {}), ...(payload.partial || {}) }
      syncRewardCatalogCommits(commit, catalogRaw)
      return dispatch('reprocessRewardsFromCache')
    },
    patchRewardsInCatalog({ commit, dispatch, state }: any, patches: Array<{ key: string, partial: any }>) {
      if (!Array.isArray(patches) || patches.length === 0) {
        return Promise.resolve(false)
      }

      const catalogRaw = { ...(state.rewards_catalog_raw || {}) }
      patches.forEach((patch) => {
        if (!patch || !patch.key) return
        catalogRaw[patch.key] = { ...(catalogRaw[patch.key] || {}), ...(patch.partial || {}) }
      })
      syncRewardCatalogCommits(commit, catalogRaw)
      return dispatch('reprocessRewardsFromCache')
    },
    async getAlluser({ commit, dispatch, state,rootState }: any, user: any) { 
      let members: any
      if (rootState.main.allUser && Object.keys(rootState.main.allUser).length > 0) {
        members = rootState.main.allUser
      } else {
        members = await getUserAll(user.company)
      }
      let membersNotUsed = (await firebase.database().ref('users_not_used').orderByChild("company").equalTo(user.company).once('value')).val()
      if(membersNotUsed){
        members = Object.assign({},members, membersNotUsed)
      }
      commit('setMemberall', members)
    },
    async getAllrewards_db({ commit, dispatch, state }: any, user: any) {
      const rewards_db = (await firebase.database().ref('rewards').orderByChild("status").once('value')).val()
      commit('setRewardsall_db', rewards_db)
    },
    async getAllrewards_company({ commit, state }: any, user: any) {
      if (hasCachedRewardCatalog(state)) {
        commit('setRewardsall_company', state.rewards_catalog_raw)
        return state.rewards_catalog_raw
      }

      const rewards_company = (await firebase.database().ref('rewards_company/'+user.company).orderByChild("status").once('value')).val()
      commit('setRewardsall_company', rewards_company)
      commit('setRewardsCatalogRaw', rewards_company || {})
      return rewards_company
    },
    getList_month({ commit, dispatch, state }: any, user: any) {
      let arr_list_month: Array<any> = [];
      let MonthTemp:Array<any> = []
      var dateNow = new Date()
      firebase.database().ref('redeem_rewards').orderByChild("company").equalTo(user.company).once('value', (snapshot) => {
        snapshot.forEach((childSnapshot) => {
            let _data = childSnapshot.val();
            let option:Array<any> = []
            option['label'] = format(_data.updated, 'MMMM YYYY')
            option['value'] = format(_data.updated, 'YYYY-MM')
            if(MonthTemp[option['value']] == undefined){
                MonthTemp[option['value']] = option
                arr_list_month.push({'num_month':format(_data.updated, 'M'),'label_month':format(_data.updated, 'MMMM YYYY'),'value':option['value']})
            }
        });
        arr_list_month = _.sortBy(arr_list_month, [function(o:any) { return o.value; }]).reverse()
        arr_list_month.push({'num_month':'all','label_month':'All Time'})
        commit('setCerrentmonth', format(new Date(),"MMMM"))
        commit('setStartmonth', format(new Date(),'MMMM YYYY'))
        commit('setList_month', arr_list_month)
      });
      // for(let i=0;i<=2;i++){
      //   arr_list_month.push({'num_month':format(addMonths(dateNow, -i), 'M'),'label_month':format(addMonths(dateNow, -i), 'MMMM YYYY')})
      // }
      // arr_list_month.push({'num_month':'-3','label_month':'Last 3 months'})
      // arr_list_month.push({'num_month':'-6','label_month':'Last 6 months'})
    },
    async getRedeemed_loadmore({ commit, dispatch, state }: any, user: any) {
      if(state.loadmore_lock == false){
        commit('setloadmoreLock', true)

        var user = user[0]
        const redeemed: Array<any> = [];
        var cur_month = state.cerrent_month
        var dateNow = new Date()

        var startAt = ''
        var endAt = state.lastDate;
        if(cur_month == '-6'){
          startAt = format(dateNow,'YYYY')+'-'+format(addMonths(dateNow, -5), 'MM')+'-01 00:00'
          commit('setStartmonth', 'Last 6 months' )
        }else if(cur_month == '-3'){
          startAt = format(dateNow,'YYYY')+'-'+format(addMonths(dateNow, -2), 'MM')+'-01 00:00'
          commit('setStartmonth', 'Last 3 months' )
        }else{
          if(cur_month == 'all'){
            startAt = '2000-01-01 00:00'
            commit('setStartmonth', 'All Time' )
          }
        }

        var limit = 100;
        var redeemed_size = 30;
        var is_full = false;
        var count_loop = 0;
        var redeemed_temp: Array<any> = [];
        var raw_data;
        while(is_full == false){
          redeemed_temp = [];
          while(redeemed_temp.length == 0){
            if(cur_month != '-6' && cur_month != 'all' && cur_month!='-3'){
        
              raw_data = (await firebase.database().ref('redeem_rewards').orderByChild('updated').startAt(startAt).endAt(endAt).once('value')).val()
              is_full = true
              commit('setLoadmore', false)
            }else if(cur_month == '-6'){
              raw_data = (await firebase.database().ref(`redeem_rewards`).orderByChild('updated').startAt(startAt).endAt(endAt).once('value')).val()
              is_full = true
              commit('setLoadmore', false)
            }else if(cur_month == '-3'){
              raw_data = (await firebase.database().ref(`redeem_rewards`).orderByChild('updated').startAt(startAt).endAt(endAt).once('value')).val()
              is_full = true
              commit('setLoadmore', false)
            }else{
              raw_data = (await firebase.database().ref(`redeem_rewards`).orderByChild('company').equalTo(`${user.company}`).once('value')).val()
              is_full = true
              commit('setLoadmore', false)
            }
            // staet : check end data
            var count_raw_data = 0
            for (var key in raw_data) {
              count_raw_data++
            }
            if(count_raw_data == 1){
              return
            }
            // end : check end data

            for (var key in raw_data) {
              const redeemedCompany = raw_data[key]
              if(redeemedCompany.company == user.company){
                var temp_id = key;
                var temp_reward = '';
                var temp_user = '';
                var temp_email = redeemedCompany.user;
                var temp_date = '';
                var temp_date_raw = redeemedCompany.updated;
                var temp_status = redeemedCompany.status;
                var temp_check_disable = false;
                let temp_processing_fee = redeemedCompany.calfee ? redeemedCompany.calfee : '';
                let temp_tax = redeemedCompany.caltax ? redeemedCompany.caltax : '';
                let temp_grand_total = Number(redeemedCompany.price) ? Number(redeemedCompany.price) : 0;
                let temp_check_rewards_company = false;
                try {
                  if(state.rewardsall_db[redeemedCompany.reward] != undefined){
                    temp_reward = state.rewardsall_db[redeemedCompany.reward].reward
                    // if(state.rewardsall_db[redeemedCompany.reward].type == 'OS'){
                    //   temp_check_disable = true;
                    // }
                  }else{
                    temp_reward = state.rewardsall_company[redeemedCompany.reward].reward
                    temp_check_rewards_company = true;
                    // if(redeemedCompany.status=="Y" || redeemedCompany.status=="C" || redeemedCompany.status=="X")
                    // {
                    //   temp_check_disable = true;
                    // }
                    // temp_check_disable = true;
                  }
                  if(redeemedCompany.status=="Y" || redeemedCompany.status=="C" || redeemedCompany.status=="X"){
                    temp_check_disable = true;
                  }
                } catch (e) {
                  temp_reward = 'none'
                }


                if(state.membersall[redeemedCompany.user.replace(/\./g, '||')] != undefined){
                  temp_user = state.membersall[redeemedCompany.user.replace(/\./g, '||')].firstname+' '+state.membersall[redeemedCompany.user.replace(/\./g, '||')].lastname
                }else{
                  temp_user = redeemedCompany.user
                }
                var dateNow = new Date(redeemedCompany.updated);
                var today = format(dateNow, 'MMM D, YYYY [at] h:mm A');
                temp_date = today;
                
                redeemed_temp.push({'id':temp_id,'check_disable':temp_check_disable,'check_rewards_company':temp_check_rewards_company,'reward':temp_reward,'user':temp_user,'email':temp_email,'date':temp_date,'date_raw':temp_date_raw,'status':temp_status,value:redeemedCompany.price, price: redeemedCompany.value, processing_fee: temp_processing_fee, tax: temp_tax, grand_total: temp_grand_total, symbol:redeemedCompany.symbol})
                // redeemed_temp.push({'user':temp_user,'email':temp_email,'date':temp_date,'date_raw':temp_date_raw,'status':temp_status})
              }
            }
            limit += 100
          }
          redeemed_temp.reverse()
          endAt = redeemed_temp[redeemed_temp.length - 1].date_raw

          if(count_loop == 0){
            redeemed_temp.forEach(function(element) {
              redeemed.push(element)
            });
            // redeemed.reverse()
          }else{
            redeemed_temp.forEach(function(element) {
              if(element.email != redeemed[redeemed.length - 1].email){
                redeemed.push(element)
              }
            });
          }
          if(redeemed.length >= redeemed_size){
            is_full = true;
          }
          
          count_loop++
        }

        endAt = redeemed[redeemed.length - 1].date_raw
        commit('setlastDate', endAt)
        
        redeemed.forEach(function(element) {
          if(element.email != state.redeemed[state.redeemed.length - 1].email){
            state.redeemed.push(element)
          }
        });
 
        commit('setLoadmore', true)
        commit('setloadmoreLock', false)
        return 
      }else{
          commit('setLoadmore', false)
          // commit('setloadmoreLock', true)
      }
    },
    async getRedeemedChart({ commit, dispatch, state ,rootState}: any, payload: any){
      const options = payload && payload.user !== undefined
        ? payload
        : { user: payload }
      const user = options.user || rootState.authen.user
      const forceRefresh = !!options.force
      const loadMode = forceRefresh
        ? (state.redeemActivityLoadedAt ? 'background' : 'blocking')
        : getRewardActivityLoadMode(state.redeemActivityLoadedAt)

      if (!forceRefresh && loadMode === 'fresh') {
        commit('setRewardActivityLoading', false)
        commit('setRewardActivityRefreshing', false)
        commit('setRewardActivityError', '')
        return state.redeemAll
      }

      if (redeemActivityRequest && !forceRefresh) {
        return redeemActivityRequest
      }

      commit('setShowTextLoading', 'Loading...')
      commit('setRewardActivityLoading', loadMode === 'blocking')
      commit('setRewardActivityRefreshing', loadMode === 'background')
      commit('setRewardActivityError', '')

      redeemActivityRequest = (async () => {
        if (!state.rewardsall_db_loaded) {
          await dispatch('getAllrewards_db', user)
        }

        if (!state.rewardsall_company || Object.keys(state.rewardsall_company).length === 0) {
          await dispatch('getAllrewards_company', user)
        }

        if (
          !rootState.main.allUser || Object.keys(rootState.main.allUser).length === 0 ||
          !rootState.main.allTeam || Object.keys(rootState.main.allTeam).length === 0
        ) {
          await dispatch('main/getuser', false, { root: true })
        }

        if (!state.allSymbol || Object.keys(state.allSymbol).length === 0) {
          await dispatch('getCountry')
        }

        // let monthAgo_13=format(subMonths(new Date(), 12),'YYYY-MM-01')
        let monthAgo_13=format('2000-01-01','YYYY-MM-01')
        const allUser=rootState.main.allUser
        const allteam=rootState.main.allTeam
        let dataChart:Array<any>=[]
        let dataPerMonth:Array<any>=[]
        let arr_list_chart:Array<any>=[]
        let label=''

        for(let i=12;i>=0;i--){
          if(format(addMonths(new Date(), -i), 'YYYY')==format(new Date(), 'YYYY'))
          {
            label=format(addMonths(new Date(), -i), 'MMM')
          }else{
            label=format(addMonths(new Date(), -i), 'MMM YYYY')
          }
          if(!arr_list_chart['num_month']){
            arr_list_chart['num_month']=[]
          }
          if(!arr_list_chart['label_month']){
            arr_list_chart['label_month']=[]
          }
          if(!arr_list_chart['label_month_year']){
            arr_list_chart['label_month_year']=[]
          }
          arr_list_chart['num_month'].push(format(addMonths(new Date(), -i), 'YYYY-MM'))
          arr_list_chart['label_month'].push(label)
          arr_list_chart['label_month_year'].push(format(addMonths(new Date(), -i), 'YYYY-MMM'))
        }

        const tax = (await firebase.database().ref(`/tax_rate`).once('value')).val();
        const cmpOpt = await getCompany(rootState.authen.user.company)
        const querySnapshot = await firebase.firestore()
          .collection('redeem_rewards')
          .where('company','==',rootState.authen.user.company)
          .where('updated','>',monthAgo_13)
          .get()

        querySnapshot.forEach((doc) => {
          const data=doc.data()
          // if(doc.id === data.redeem_rewards_id){ //Detect Gift type rewards will have 2 records.
          if(data.type !== 'gift' || (data.type == 'gift' && doc.id.slice(-2) !== '-2')){ //Detect Gift type rewards will have 2 records.
            const date=format(new Date(data.updated),"YYYY-MM")
            data.id=doc.id
            if(!dataChart[date]){
              dataChart[date]=0
            }

            let calfee:any
            if(data['exchangerate'] && data['exchangerate'].conversion_result){
              data.price = data['exchangerate'].conversion_result
            }
            if(data.feerate == undefined){
              if(state.rewardsall_db[data.reward] !== undefined){
                data.feerate = state.rewardsall_db[data.reward].feerate
              } else if(state.rewardsall_company[data.reward]){
                data.feerate = state.rewardsall_company[data.reward].feerate
              }
            }
            if(data.feerate_happily == undefined){
              if(state.rewardsall_db[data.reward] !== undefined){
                data.feerate_happily = state.rewardsall_db[data.reward].feerate_happily
              } else if(state.rewardsall_company[data.reward]){
                data.feerate_happily = state.rewardsall_company[data.reward].feerate_happily
              }
            }
            if(data.price !== undefined && Number(data.price) !== 0){
              data.price = Number(data.price)
            }else{
              data.price = 0
            }
            if((data.feerate !== undefined && data.feerate !== 0) && (data.feerate_happily !== undefined && data.feerate_happily !== 0) && (data.status == 'Y' || data.status_send == 'SC')){
                if(data.feerate_happily > data.feerate){
                    calfee =  (Number(data.price) * data.feerate_happily) / 100
                }else{
                    calfee =  (Number(data.price) * data.feerate) / 100
                }
            } else if(data.feerate !== undefined && data.feerate !== 0 && (data.status == 'Y' || data.status_send == 'SC')){
                calfee =  (Number(data.price) * data.feerate) / 100
            } else if(data.feerate_happily !== undefined && data.feerate_happily !== 0 && (data.status == 'Y' || data.status_send == 'SC')){
                calfee =  (Number(data.price) * data.feerate_happily) / 100
            }
            data.firstprice = Number(data.price)
            data.value = Number(data.firstprice)
            if(state.rewardsall_db[data.reward] !== undefined){
              data.newtype = state.rewardsall_db[data.reward].newtype
              data.reward_currency = state.rewardsall_db[data.reward].reward_currency
              let country = state.rewardsall_db[data.reward].country !== undefined ? state.rewardsall_db[data.reward].country : ''
              if (country && tax[country]) {
                data.taxrate = tax[country].rate;
              }
            } else if(state.rewardsall_company[data.reward] !== undefined) {
              data.newtype = state.rewardsall_company[data.reward].newtype
              data.reward_currency = state.rewardsall_company[data.reward].reward_currency
              let country = state.rewardsall_company[data.reward].country !== undefined ? state.rewardsall_company[data.reward].country : ''
              if (country && tax[country]) {
                data.taxrate = tax[country].rate;
              }
            }else{
              data.reward_currency = (cmpOpt.billing_currency) ? cmpOpt.billing_currency : 'THB'
            }
            /* For reward has been deleted */
            if(data.reward_currency == undefined){
              data.reward_currency = (cmpOpt.billing_currency) ? cmpOpt.billing_currency : 'THB'
            }
            /* End For reward has been deleted */
            if(data['exchangerate'] && data['exchangerate'].target_code){
              data.symbol = state.allSymbol[data['exchangerate'].target_code]
              data.reward_currency = data['exchangerate'].target_code
            }else{
              if(data.reward_currency){
                data.symbol = state.allSymbol[data.reward_currency]
              }else{
                data.symbol = '฿'
              }
            }
            if(data.newtype && data.newtype == 'Item'){
              if((data.feerate !== undefined && data.feerate !== 0) || (data.feerate_happily !== undefined && data.feerate_happily !== 0) && (data.status == 'Y' || data.status_send == 'SC')){
                if(data.feerate && data.feerate_happily){
                  if(data.feerate_happily > data.feerate){
                    data.price =  Number(data.price) + ((Number(data.price) * data.feerate_happily) / 100)
                    data.firstfee = (Number(data.firstprice) * data.feerate_happily) / 100
                  }else{
                    data.price =  Number(data.price) + ((Number(data.price) * data.feerate) / 100)
                    data.firstfee = (Number(data.firstprice) * data.feerate) / 100
                  }
                }else if(data.feerate){
                  data.price =  Number(data.price) + ((Number(data.price) * data.feerate) / 100)
                  data.firstfee = (Number(data.firstprice) * data.feerate) / 100
                }else if(data.feerate_happily){
                  data.price =  Number(data.price) + ((Number(data.price) * data.feerate_happily) / 100)
                  data.firstfee = (Number(data.firstprice) * data.feerate_happily) / 100
                }
              }
              if(data.taxrate && data.taxrate > 0){
                let caltax = (Number(data.price) * Number(data.taxrate))/100
                data.price = Number(data.price) + ((Number(data.price) * Number(data.taxrate))/100)
                data.caltax = Number(caltax)
                data.firsttax =  Number(caltax)
              }
            }else{
              if((data.feerate !== undefined && data.feerate !== 0) || (data.feerate_happily !== undefined && data.feerate_happily !== 0) && (data.status == 'Y' || data.status_send == 'SC')){
                if(data.taxrate && data.taxrate > 0){
                  let caltax = (calfee * Number(data.taxrate))/100
                  data.price = Number(data.price) + Number(calfee) + Number(caltax)
                  data.caltax = Number(caltax)
                  data.firsttax =  Number(caltax)
                }else{
                  if(calfee){
                    data.price = Number(data.price) + Number(calfee)
                    data.firstfee = Number(calfee)
                  }
                }
              }
            }
            data.calfee = Number(calfee)
            data.firstfee = Number(data.calfee)

            if(!dataPerMonth[date]){
              dataPerMonth[date]=[]
            }
            dataPerMonth[date].push(data)

            if(data.firstprice && data.status == 'Y' || data.status_send == 'SC'){
              dataChart[date]+=Number(data.firstprice)
            }
          }
        })

        var redeemed_temp: Array<any> = [];
        const date_Now=format(new Date(),"YYYY-MM")
        const currentMonthData = dataPerMonth[date_Now] || []
        for (var key in currentMonthData) {
          const redeemedCompany = currentMonthData[key]
          if(redeemedCompany.company == rootState.authen.user.company){
            var temp_id =redeemedCompany.id;
            var temp_reward = '';
            var temp_user = '';
            var temp_user_pic = '';
            var temp_user_team = '';
            var temp_send_to = '';
            var temp_pic= '';
            var temp_email = redeemedCompany.user;
            var temp_type = redeemedCompany.type;
            var temp_date = '';
            var temp_team = '';
            var temp_date_raw = redeemedCompany.updated;
            var temp_status = redeemedCompany.status;
            var temp_status_send = redeemedCompany.status_send;
            var temp_check_disable = false;
            let temp_processing_fee = redeemedCompany.calfee ? redeemedCompany.calfee : '';
            let temp_tax = (redeemedCompany.calfee && redeemedCompany.caltax) ? redeemedCompany.caltax : '';
            let temp_grand_total = Number(redeemedCompany.price) ? Number(redeemedCompany.price) : 0;
            let temp_check_rewards_company = false;
            try {
              if(state.rewardsall_db[redeemedCompany.reward] != undefined){
                temp_reward = state.rewardsall_db[redeemedCompany.reward].reward
              }else{
                temp_reward = state.rewardsall_company[redeemedCompany.reward].reward
                temp_check_rewards_company = true;
              }
              if(redeemedCompany.status=="Y" || redeemedCompany.status=="C" || redeemedCompany.status=="X"){
                temp_check_disable = true;
              }
            } catch (e) {
              temp_reward = 'none'
            }
            if(allUser[redeemedCompany.user.replace(/\./g, '||')] != undefined){
              const member = allUser[redeemedCompany.user.replace(/\./g, '||')]
              temp_user = member.firstname+' '+member.lastname
              temp_user_pic = member.profilepic || ''
              temp_user_team = allteam[member.team] ? allteam[member.team].name : ''
            }else{
              temp_user = redeemedCompany.user
            }
            if(redeemedCompany.send_to){
              if(allUser[redeemedCompany.send_to.replace(/\./g, '||')] != undefined){
                temp_send_to = allUser[redeemedCompany.send_to.replace(/\./g, '||')].firstname+' '+allUser[redeemedCompany.send_to.replace(/\./g, '||')].lastname
                temp_pic=allUser[redeemedCompany.send_to.replace(/\./g, '||')].profilepic
                temp_team=allteam[allUser[redeemedCompany.send_to.replace(/\./g, '||')].team].name
              }else{
                temp_send_to = redeemedCompany.send_to
                temp_pic=''
                temp_team=''
              }
            }else{
              if(allUser[redeemedCompany.user.replace(/\./g, '||')] != undefined){
                temp_send_to = allUser[redeemedCompany.user.replace(/\./g, '||')].firstname+' '+allUser[redeemedCompany.user.replace(/\./g, '||')].lastname
                temp_pic=allUser[redeemedCompany.user.replace(/\./g, '||')].profilepic
                temp_team=allteam[allUser[redeemedCompany.user.replace(/\./g, '||')].team].name
              }else{
                temp_send_to = redeemedCompany.user
                temp_pic=''
                temp_team=''
              }
            }
            var dateNow = new Date(redeemedCompany.updated);
            var today = format(dateNow, 'MMM D, YYYY [at] h:mm A');
            temp_date = today;
            redeemed_temp.push({'id':temp_id,'check_disable':temp_check_disable,'check_rewards_company':temp_check_rewards_company,'reward':temp_reward,'user':temp_user,'user_pic':temp_user_pic,'user_team':temp_user_team,'email':temp_email,'date':temp_date,'date_raw':temp_date_raw,'status':temp_status,'status_send':temp_status_send,'send_to':temp_send_to,'type':temp_type,pic:temp_pic,team:temp_team,value:redeemedCompany.firstprice, price: redeemedCompany.value, processing_fee: temp_processing_fee, tax: temp_tax, grand_total: temp_grand_total, symbol:redeemedCompany.symbol, reward_currency:redeemedCompany.reward_currency})
          }
        }
        let _dataChart:Array<any>=[]
        for(const value in arr_list_chart['num_month']){
          _dataChart.push(dataChart[arr_list_chart['num_month'][value]])
        }
        redeemed_temp.reverse()
        commit('setredeemed', redeemed_temp)
        commit('setRedeemAll', dataPerMonth)
        commit('setDataChart', {data:_dataChart,...arr_list_chart})
        commit('setRedeemActivityLoadedAt', Date.now())

        return dataPerMonth
      })()

      try {
        return await redeemActivityRequest
      } catch (error) {
        const message = error && error.message ? error.message : 'Unable to load reward activity'
        if (loadMode === 'blocking') {
          commit('setRewardActivityError', message)
        }
        throw error
      } finally {
        commit('setRewardActivityLoading', false)
        commit('setRewardActivityRefreshing', false)
        redeemActivityRequest = null
      }
    },
    async getRedeemedSelectMonth({ commit, dispatch, state ,rootState}: any, month: any){
      var cur_month = month[1]
      if (
        !rootState.main.allUser || Object.keys(rootState.main.allUser).length === 0 ||
        !rootState.main.allTeam || Object.keys(rootState.main.allTeam).length === 0
      ) {
        await dispatch('main/getuser', false, { root: true })
      }
      const allUser=rootState.main.allUser
      const allteam=rootState.main.allTeam
      let dataPerMonth=state.redeemAll
      let _dataPerMonth: Array<any> = [];
      commit('setShowTextLoading', 'Loading...')
      var dateNow = new Date()
      
      if(typeof cur_month === 'string' && cur_month.startsWith('custom:')){
        // Handle custom date range format: custom:YYYY-MM-DD:YYYY-MM-DD
        const parts = cur_month.split(':')
        if(parts.length === 3){
          const startDateStr = parts[1]
          const endDateStr = parts[2]
          const startDate = new Date(startDateStr + 'T00:00:00')
          const endDate = new Date(endDateStr + 'T23:59:59')
          
          // Iterate through months between start and end dates
          let currentMonth = new Date(startDate)
          currentMonth.setDate(1) // Start of month
          
          while(currentMonth <= endDate){
            const monthKey = format(currentMonth, 'YYYY-MM')
            if(dataPerMonth[monthKey] != undefined && Array.isArray(dataPerMonth[monthKey])){
              // Filter items within this month by date range
              const monthData = dataPerMonth[monthKey]
              const filteredData = monthData.filter((item: any) => {
                if(!item || !item.updated) return false
                const itemDate = new Date(item.updated)
                return itemDate >= startDate && itemDate <= endDate
              })
              _dataPerMonth.push(...filteredData)
            }
            currentMonth = addMonths(currentMonth, 1)
          }
          
          const startFormatted = format(startDate, 'MMM D, YYYY')
          const endFormatted = format(endDate, 'MMM D, YYYY')
          commit('setStartmonth', `${startFormatted} To ${endFormatted}`)
          commit('setCerrentmonth', format(startDate, 'M'))
        }
      }else{
        var split_month = cur_month.split("-")
        commit('setCerrentmonth', split_month[1])
        
        if(cur_month == '-6'){
          for(let i=0;i<5;i++){
            const date=format(addMonths(dateNow, -i),'YYYY-MM')
            if(dataPerMonth[date] != undefined){
              _dataPerMonth.push(...dataPerMonth[date])
            }
          }
          commit('setStartmonth', 'Last 6 months' )
        }else if(cur_month == '-3'){
          for(let i=0;i<3;i++){
            const date=format(addMonths(dateNow, -i),'YYYY-MM')
            if(dataPerMonth[date] != undefined){
              _dataPerMonth.push(...dataPerMonth[date])
            }
          }
        
          commit('setStartmonth', 'Last 3 months' )
        }else if(cur_month == 'all'){
          let startDate = format('2000-01-01','YYYY-MM-DD')
          let endDate = format(dateNow,'YYYY-MM-DD')
          do{
            const date=format(startDate,'YYYY-MM')
            if(dataPerMonth[date] != undefined){
              _dataPerMonth.push(...dataPerMonth[date])
            }
            startDate = format(addMonths(startDate, 1),'YYYY-MM-DD')
          }
          while(startDate < endDate)
        }else{
          _dataPerMonth=dataPerMonth[ format(cur_month, 'YYYY-MM')] || []
         
        }
      }
        var redeemed_temp: Array<any> = [];
        for (var key in _dataPerMonth) {
          const redeemedCompany = _dataPerMonth[key]
          if(redeemedCompany.company == rootState.authen.user.company){
            var temp_id = redeemedCompany.id;
            var temp_reward = '';
            var temp_user = '';
            var temp_user_pic = '';
            var temp_user_team = '';
            var temp_send_to = '';
            var temp_pic= '';
            var temp_email = redeemedCompany.user;
            var temp_type = redeemedCompany.type;
            var temp_date = '';
            var temp_team = '';
            var temp_date_raw = redeemedCompany.updated;
            var temp_status = redeemedCompany.status;
            var temp_status_send = redeemedCompany.status_send;
            var temp_check_disable = false;
            let temp_processing_fee = redeemedCompany.calfee ? redeemedCompany.calfee : '';
            let temp_tax = (redeemedCompany.calfee && redeemedCompany.caltax) ? redeemedCompany.caltax : '';
            let temp_grand_total = Number(redeemedCompany.price) ? Number(redeemedCompany.price) : 0;
            let temp_check_rewards_company = false;
            try {
              if(state.rewardsall_db[redeemedCompany.reward] != undefined){
                temp_reward = state.rewardsall_db[redeemedCompany.reward].reward
                // if(state.rewardsall_db[redeemedCompany.reward].type == 'OS'){
                //   temp_check_disable = true;
                // }
              }else{
                temp_reward = state.rewardsall_company[redeemedCompany.reward].reward
                temp_check_rewards_company = true;
                // if(redeemedCompany.status=="Y" || redeemedCompany.status=="C" || redeemedCompany.status=="X")
                // {
                //   temp_check_disable = true;
                // }
                // temp_check_disable = true;
              }
              if(redeemedCompany.status=="Y" || redeemedCompany.status=="C" || redeemedCompany.status=="X"){
                temp_check_disable = true;
              }
            } catch (e) {
              temp_reward = 'none'
            }
            if(allUser[redeemedCompany.user.replace(/\./g, '||')] != undefined){
              const member = allUser[redeemedCompany.user.replace(/\./g, '||')]
              temp_user = member.firstname+' '+member.lastname
              temp_user_pic = member.profilepic || ''
              temp_user_team = allteam[member.team] ? allteam[member.team].name : ''
            }else{
              temp_user = redeemedCompany.user
            }
            
            if(redeemedCompany.send_to){
              if(allUser[redeemedCompany.send_to.replace(/\./g, '||')] != undefined){
                temp_send_to = allUser[redeemedCompany.send_to.replace(/\./g, '||')].firstname+' '+allUser[redeemedCompany.send_to.replace(/\./g, '||')].lastname
                temp_pic=allUser[redeemedCompany.send_to.replace(/\./g, '||')].profilepic
                temp_team=allteam[allUser[redeemedCompany.send_to.replace(/\./g, '||')].team].name
              }else{
                temp_send_to = redeemedCompany.send_to
                temp_pic=''
                temp_team=''
              }
            }else{
                if(allUser[redeemedCompany.user.replace(/\./g, '||')] != undefined){
                  temp_send_to = allUser[redeemedCompany.user.replace(/\./g, '||')].firstname+' '+allUser[redeemedCompany.user.replace(/\./g, '||')].lastname
                  temp_pic=allUser[redeemedCompany.user.replace(/\./g, '||')].profilepic
                  temp_team=allteam[allUser[redeemedCompany.user.replace(/\./g, '||')].team].name
                }else{
                  temp_send_to = redeemedCompany.user
                  temp_pic=''
                  temp_team=''
              }
            }
            var dateNow = new Date(redeemedCompany.updated);
            var today = format(dateNow, 'MMM D, YYYY [at] h:mm A');
            temp_date = today;
            redeemed_temp.push({'id':temp_id,'check_disable':temp_check_disable,'check_rewards_company':temp_check_rewards_company,'reward':temp_reward,'user':temp_user,'user_pic':temp_user_pic,'user_team':temp_user_team,'email':temp_email,'date':temp_date,'date_raw':temp_date_raw,'status':temp_status,'status_send':temp_status_send,'send_to':temp_send_to,'type':temp_type,pic:temp_pic,team:temp_team,value:redeemedCompany.firstprice, price: redeemedCompany.value, processing_fee: temp_processing_fee, tax: temp_tax, grand_total: temp_grand_total, symbol:redeemedCompany.symbol, reward_currency:redeemedCompany.reward_currency})
// 
          }
        }
        //console.log("redeemed_temp",redeemed_temp)
        redeemed_temp.reverse()
        commit('setredeemed', redeemed_temp)

    },
    exportTable({ commit, dispatch, state ,rootState}: any, month: any){
      let fileName = ''
      if(month == 'all'){
        fileName = 'All Time'
      }else if(typeof month === 'string' && month.startsWith('custom:')){
        // Handle custom date range format: custom:YYYY-MM-DD:YYYY-MM-DD
        const parts = month.split(':')
        if(parts.length === 3){
          const startDate = parts[1]
          const endDate = parts[2]
          fileName = `Custom Range - ${format(startDate, 'YYYY-MM-DD')} to ${format(endDate, 'YYYY-MM-DD')}`
        }else{
          fileName = 'Custom Range'
        }
      }else{
        fileName = format(month,'MMMM YYYY')
      }
      const Excel = require("exceljs");
      var wb = new Excel.Workbook();
      var ws = wb.addWorksheet("mySheet");
      let header = [
        "",
        "Reward Name",
        "Redeemed By",
        "Redeemer Email",
        "Recipient",
        "Recipient Team",
        "Reward Value",
        "Processing Fees",
        "VAT",
        "Grand Total",
        "Currency",
        "Type",
        "Date and Time",
        "Status",
      ];
      ws.getRow(1).values = header;
           //   /*Data*/
      _.forEach(state.redeemed, (item, key) => {
        let status=""
        if(item.status == 'N'){
          status="Processing"
        }else if(item.status == 'P'){
          status="Processing"
        }else if(item.status == 'Y' || item.status_send == 'SC'){
          status="Delivered"
        }else if(item.status == 'X'){
          status="Cancel"
        }
        let _tmp = [
          "",
          item.reward,
          item.user,
          item.email,
          item.send_to,
          item.team,
          item.value,
          item.processing_fee,
          item.tax,
          item.grand_total,
          item.reward_currency,
          item.type,
          item.date,
          status,
        ];
        ws.addRow(_tmp);
      });
      wb.xlsx
        .writeBuffer({
          base64: true,
        })
        .then(function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download =fileName+ ".xlsx";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);

        })
        .catch(function (error) {
          console.error('Error exporting rewards data:', error.message);
        });
    },
    exportMemberSpend({ commit }: any, payload: any){
      const rows = payload && Array.isArray(payload.rows) ? payload.rows : []
      const rawPeriod = payload && payload.period ? String(payload.period) : 'Current Period'
      const period = rawPeriod.replace(/[\\/:*?"<>|]/g, '-')
      const Excel = require("exceljs")
      const wb = new Excel.Workbook()
      const ws = wb.addWorksheet("Member Spend")
      ws.getRow(1).values = [
        "Member",
        "Email",
        "Team",
        "Currency",
        "Redemptions",
        "Reward Spend",
        "Share of Currency Spend",
        "Last Activity",
      ]

      rows.forEach((item: any) => {
        ws.addRow([
          item.name,
          item.email,
          item.team,
          item.currency,
          item.redemptions,
          item.amount,
          Number(item.share || 0) / 100,
          item.lastActivity,
        ])
      })
      ws.getColumn(7).numFmt = '0.0%'

      return wb.xlsx.writeBuffer({ base64: true }).then((xls64: any) => {
        const a = document.createElement("a")
        const data = new Blob([xls64], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
        const url = URL.createObjectURL(data)
        a.href = url
        a.download = `Reward Member Spend - ${period}.xlsx`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
      }).catch((error: any) => {
        console.error('Error exporting reward member spend:', error.message)
      })
    },
    // async getRedeemed({ commit, dispatch, state }: any, user: any) {
    //   var cur_month = user[1]
    //   var user = user[0]
    //   const redeemed: Array<any> = [];
    //   commit('setredeemed', redeemed)
    //   var dateNow = new Date()
    //   var split_month = cur_month.split("-")
    //   commit('setCerrentmonth', split_month[1])
    //   commit('setStartmonth', format( cur_month+'-01 00:00','MMMM YYYY'))
    //   var startAt = ''
    //   var endAt = ''
    //   if(cur_month == '-6'){
    //     var nowYear = format(dateNow,'YYYY')
    //     if(parseInt( format(dateNow, 'M') ) < 6){
    //       nowYear = format(addYears(dateNow, -1),'YYYY')
    //     }
        
    //     startAt = nowYear+'-'+format(addMonths(dateNow, -5), 'MM')+'-01 00:00'
    //     endAt = format(dateNow,'YYYY')+'-'+format(dateNow,'MM')+'-31 23:59'
    //     commit('setStartmonth', 'Last 6 months' )
    //   }else if(cur_month == '-3'){
    //     var nowYear = format(dateNow,'YYYY')
    //     if(parseInt( format(dateNow, 'M') ) < 3){
    //       nowYear = format(addYears(dateNow, -1),'YYYY')
    //     }
    //     startAt = nowYear+'-'+format(addMonths(dateNow, -2), 'MM')+'-01 00:00'
    //     endAt = format(dateNow,'YYYY')+'-'+format(dateNow,'MM')+'-31 23:59'
    //     commit('setStartmonth', 'Last 3 months' )
    //   }else{
    //     if(cur_month == 'all'){
    //       startAt = '2000-01-01 00:00'
    //       endAt = format(dateNow,'YYYY')+'-'+format(dateNow,'MM')+'-31 23:59'
    //       commit('setStartmonth', 'All Time' )
    //     }else{
    //       startAt = cur_month+'-01 00:00'
    //       endAt = cur_month+'-31 23:59'
    //     }
    //   }
    //   var redeemed_temp: Array<any> = [];
    //   var raw_data;
    //       if(cur_month != '-6' && cur_month != 'all'&&cur_month != '-3'){
    //         raw_data = (await firebase.database().ref('redeem_rewards').orderByChild('updated').startAt(startAt).endAt(endAt).once('value')).val()
    //         commit('setLoadmore', false)
    //       }else if(cur_month == '-6'){
    //         raw_data = (await firebase.database().ref(`redeem_rewards`).orderByChild('updated').startAt(startAt).endAt(endAt).once('value')).val()
    //         commit('setLoadmore', false)
    //       }else if(cur_month == '-3'){
    //         raw_data = (await firebase.database().ref(`redeem_rewards`).orderByChild('updated').startAt(startAt).endAt(endAt).once('value')).val()
    //         commit('setLoadmore', false)
    //       }
    //       else{
    //         raw_data = (await firebase.database().ref(`redeem_rewards`).orderByChild('company').equalTo(`${user.company}`).once('value')).val()
    //         commit('setLoadmore', false)
    //       }
       
    //       for (var key in raw_data) {
            
    //         const redeemedCompany = raw_data[key]
    //         if(redeemedCompany.company == user.company){
    //           var temp_id = key;
    //           var temp_reward = '';
    //           var temp_user = '';
    //           var temp_send_to = '';
    //           var temp_email = redeemedCompany.user;
    //           var temp_type = redeemedCompany.type;
    //           var temp_date = '';
    //           var temp_date_raw = redeemedCompany.updated;
    //           var temp_status = redeemedCompany.status;
    //           var temp_check_disable = false;
    //           try {
    //             if(state.rewardsall_db[redeemedCompany.reward] != undefined){
    //               temp_reward = state.rewardsall_db[redeemedCompany.reward].reward
    //               if(state.rewardsall_db[redeemedCompany.reward].type == 'OS'){
    //                 temp_check_disable = true;
    //               }
    //             }else{
    //               temp_reward = state.rewardsall_company[redeemedCompany.reward].reward
    //               if(redeemedCompany.status=="Y")
    //               {
    //                 temp_check_disable = true;
    //               }
    //               // temp_check_disable = true;
    //             }
    //           } catch (e) {
    //             temp_reward = 'none'
    //           }
    //           if(state.membersall[redeemedCompany.user.replace(/\./g, '||')] != undefined){
    //             temp_user = state.membersall[redeemedCompany.user.replace(/\./g, '||')].firstname+' '+state.membersall[redeemedCompany.user.replace(/\./g, '||')].lastname
    //           }else{
    //             temp_user = redeemedCompany.user
    //           }
    //           if(redeemedCompany.send_to){
    //             if(state.membersall[redeemedCompany.send_to.replace(/\./g, '||')] != undefined){
    //               temp_send_to = state.membersall[redeemedCompany.send_to.replace(/\./g, '||')].firstname+' '+state.membersall[redeemedCompany.send_to.replace(/\./g, '||')].lastname
    //             }else{
    //               temp_send_to = redeemedCompany.send_to
    //             }
    //           }
    //           var dateNow = new Date(redeemedCompany.updated);
    //           var today = format(dateNow, 'MMM D, YYYY [at] H:m A');
    //           temp_date = today;
    //           redeemed_temp.push({'id':temp_id,'check_disable':temp_check_disable,'reward':temp_reward,'user':temp_user,'email':temp_email,'date':temp_date,'date_raw':temp_date_raw,'status':temp_status,'send_to':temp_send_to,'type':temp_type})
    //         }
    //       }
    //     redeemed_temp.reverse()
    //     commit('setredeemed', redeemed_temp)
    //   return 
    // },
    async getProcessingRedeemed({ commit, dispatch, state }: any, user: any){
      var count=0
      firebase.database().ref(`redeem_rewards`).orderByChild('company').equalTo(`${user.company}`).once("value").then(function (snapshot) {
        snapshot.forEach((childSnapshot) => {
          var _data = childSnapshot.val();
          // console.log("getProcessingRedeemed",_data)
          if(_data.status=="N"||_data.status=="P")
          {
           count++ 
          }
        })
        commit('setProcessingRedeemed', count)
      })
    },
    searchRewards({ commit, dispatch, rootState, state }: any, value: string) {
      var re = new RegExp(value, 'gi')
      const rewards = (state.selectShow) ? state.rewards : state.rewardsall
      if (value) {
        var response = _.filter(rewards, (item): any => {
          if (item.reward_en.match(re)) {
            return true
          } else if (item.description_en.match(re)) {
            return true
          }
        });
        commit('setrewardsSearch', response)
        commit('setrewards', response)
      } else {
        dispatch('applyRewardFilters')
      }
    },
    selectStatus({ commit, dispatch, state }: any, value: string) {
      const rewards = (state.inputSearch) ? state.rewardssearch : state.rewardsall
      if (value != 'all') {
        var response = _.filter(rewards, (item): any => {
          if (item.status.match(value)) {
            return true
          }
        });
        commit('setrewards', response)
      } else {
        dispatch('applyRewardFilters')
      }
    },
    activateReward({ commit, rootState, dispatch }: any, reward: any) {
      firebase.database().ref(`rewards_company/${rootState.authen.user.company}/${reward.key}`).update({ status: 'Y' }).then(() => {
        /*save logs*/
        
        dispatch('authen/addLogs', {
          company: rootState.authen.user.company,
          createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          id: reward.key,
          table: 'rewards_company',
          status: 'activate',
          user: rootState.authen.user.email
        }, {root:true}).then(function() {
          dispatch('patchRewardInCatalog', { key: reward.key, partial: { status: 'Y' } })
        });
      });
    },
    deleteReward({ commit, rootState, dispatch }: any, value: any) {
      var newId = value.key
      firebase.database().ref(`rewards_company/${rootState.authen.user.company}/${newId}`).update({
        show:'N',
        status:'N',
      }).then(()=> {
        dispatch('authen/addLogs', {
          company: rootState.authen.user.company,
          createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          id: newId,
          table: 'rewards_company_delete',
          status: 'delete',
          user: rootState.authen.user.email
        }, {root:true}).then(function() {
          dispatch('patchRewardInCatalog', { key: newId, partial: { show: 'N', status: 'N' } })
        });
      });
      /*firebase.database().ref(`rewards_company_delete/${rootState.authen.user.company}/${newId}`).update(
        {
          coins: value.coins ? value.coins : 0,
          company: rootState.authen.user.company,
          description: value.description,
          description_en: value.description,
          gems: value.gems ? value.gems : 0,
          promotion: value.qty ? 'Y' : 'N',
          qty: value.qty,
          reward: value.name,
          reward_en: value.name,
          status: 'Y',
          type: value.type,
          starton: format(value.duration[0], 'DD/MM/YYYY HH:mm'),
          endon: format(value.duration[1], 'DD/MM/YYYY HH:mm')
        }
      ).then(() => {
        /*save logs*/
        /*dispatch('authen/addLogs', {
          company: rootState.authen.user.company,
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            id: newId,
            table: 'rewards_company_delete',
            status: 'delete',
            user: rootState.authen.user.email
        }, {root:true})
      });*/
      
    },
    disableReward({ commit, rootState, dispatch }: any, reward: any) {
      firebase.database().ref(`rewards_company/${rootState.authen.user.company}/${reward.key}`).update({ status: 'N' }).then(() => {
        /*save logs*/
        dispatch('authen/addLogs', {
          company: rootState.authen.user.company,
          createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          id: reward.key,
          table: 'rewards_company',
          status: 'disable',
          user: rootState.authen.user.email
        }, {root:true}).then(()=> {
          dispatch('patchRewardInCatalog', { key: reward.key, partial: { status: 'N' } })
        });
      });
    },
    redeemed_change({ commit, rootState }: any, data: any) {
      if(data[1] == 'C'){
        firebase.database().ref(`redeem_rewards/${data[0]}`).update({ status: data[1], refund:true, updateby:rootState.authen.user.email, updatedadmin:format(new Date(), 'YYYY-MM-DD HH:mm') }).then(()=>{
          
          firebase.firestore().collection(`redeem_rewards`).doc(data[0]).update({ status:data[1], refund:true, updateby:rootState.authen.user.email, updatedadmin:format(new Date(), 'YYYY-MM-DD HH:mm') }).then(()=>{
            commit('updateRedeemedStatus', { id: data[0], status: data[1] })
          });
          //dispatch('getRedeemedSelectMonth',[data[2],data[3]])
        });
      }else{
        firebase.database().ref(`redeem_rewards/${data[0]}`).update({ status: data[1], updateby:rootState.authen.user.email, updatedadmin:format(new Date(), 'YYYY-MM-DD HH:mm') }).then(()=>{

          firebase.firestore().collection(`redeem_rewards`).doc(data[0]).update({ status:data[1], updateby:rootState.authen.user.email, updatedadmin:format(new Date(), 'YYYY-MM-DD HH:mm') }).then(()=>{
            commit('updateRedeemedStatus', { id: data[0], status: data[1] })
          });
          //dispatch('getRedeemedSelectMonth',[data[2],data[3]])
        });
      }
      
     
    },
    createReward({ commit, rootState, dispatch }: any, value: any) {
      let tag_value = value.type
      const currentMonth = format(new Date(), 'YYYY-MM')
      const isMonthly = !!value.isMonthly
      var data: any = {
        coins: value.costSelected == 'coins' ? value.cost * 1 : 0,
        company: rootState.authen.user.company,
        descriptions: value.descriptions,
        description: value.descriptions.th?value.descriptions.th:value.descriptions.en,
        description_en: value.descriptions.en,
        gems: value.costSelected == 'gems' ? value.cost * 1 : 0,
        promotion: value.quantity ? 'Y' : 'N',
        qty: value.quantityLimits?Number(value.quantityLimits):0,
        monthly_period: isMonthly ? currentMonth : null,
        rewards: value.names,
        reward: value.names.th?value.names.th:value.names.en,
        reward_en: value.names.en,
        status: 'Y',
        show:'Y',
        // type: value.type,
        starton: format(value.duration[0], 'DD/MM/YYYY HH:mm'),
        endon: format(value.duration[1], 'DD/MM/YYYY HH:mm'),
        updateby: rootState.authen.user.email,
        updatetime: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        createtime: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        price: 0
      }
      if(!data.descriptions.th){
        data.descriptions.th=value.descriptions.en
      }
      if(!data.rewards.th){
        data.rewards.th=value.names.en
      }
      var tmp_image ={file: value.file} 
      if(value.country!="All Countries"){
        Object.assign(data, {country: value.country});
      }
      if(value.approval==true){
        Object.assign(data, {approval_reward: "Y"});
      }
      let tag = [tag_value]
      if(tag_value == '0'){  // Gift Cards
        Object.assign(data, {type: 'OS', tag: tag, newtype: "Gift card"});
      }else if(tag_value == '1'){  // Team Building
        Object.assign(data, {type: 'OS', tag: tag, newtype: "Group Reward"});
      }else if(tag_value == '2'){  // Doing Good
        Object.assign(data, {type: 'OS', tag: tag, newtype: "Donation"});
      }else if(tag_value == '3'){  // Perks
        Object.assign(data, {type: 'IS', tag: tag, newtype: "Company Reward"});
      }else{
        Object.assign(data, {type: 'OS', tag: tag, newtype: "Company Reward"});
      }
      // if(data.type=="OS")
      // {
      //   Object.assign(data, {newtype: "Gift card"});
      // }
      // if(value.quantity){
      //   Object.assign(data, {limit: value.quantityLimits});
      // }
      const newId = firebase.database().ref(`rewards_company/${rootState.authen.user.company}`).push().key
      firebase.database().ref(`rewards_company/${rootState.authen.user.company}/${newId}`).update(
       data
      ).then(() => {
        if (tmp_image.file.length > 0) {
          const imageName = sanitizeRewardFilename(tmp_image.file[0].name)
          firebase.storage().ref(`images/reward_company/${rootState.authen.user.company}/${newId}/${imageName}`)
            .put(tmp_image.file[0]).then((snapshot) => {
              if (snapshot.state == 'success') {
                const update = {
                  filename: imageName,
                  filepath: `images/reward_company/${rootState.authen.user.company}/${newId}/${imageName}`
                };
                firebase.database().ref(`rewards_company/${rootState.authen.user.company}/${newId}`).update(update).then(() => {
                  /*save logs*/
                  dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: newId,
                    table: 'rewards_company',
                    status: 'add',
                    user: rootState.authen.user.email
                  }, {root:true}).then(function() {
                    dispatch('patchRewardInCatalog', {
                      key: newId,
                      partial: Object.assign({}, data, update),
                    })
                  });
                });
              }
            });
        }
        else{
          /*save logs*/
          dispatch('authen/addLogs', {
            company: rootState.authen.user.company,
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            id: newId,
            table: 'rewards_company',
            status: 'add',
            user: rootState.authen.user.email
          }, {root:true}).then(function() {
            dispatch('patchRewardInCatalog', { key: newId, partial: data })
          });
        }
      });
    },
    updateReward({ commit, rootState, state, dispatch }: any, value: any) {
      const data = _.find(state.rewards, function(o) { return o.key === value.key; });
      let savedata = {}
      var tmp_image ={file: value.file,filename:value.filename} 
      let country=value.country
      let approval_reward=value.approval
      let tag_value = value.type
      //console.log("data",data)
      const isMonthly = !!value.isMonthly
      const currentMonth = format(new Date(), 'YYYY-MM')
      const nextMonthlyPeriod = isMonthly ? currentMonth : null
      if(data.edit === 'N') {
        savedata = {
          coins: value.costSelected == 'coins' ? value.cost * 1 : 0,
          gems: value.costSelected == 'gems' ? value.cost * 1 : 0,
          promotion: value.quantity ? 'Y' : 'N',
          qty: (Number(value.quantity))?Number(value.quantityLimits):0,
          monthly_period: nextMonthlyPeriod,
        }
      }else{
        savedata = {
          coins: value.costSelected == 'coins' ? value.cost * 1 : 0,
          company: rootState.authen.user.company,
          descriptions: value.descriptions,
          description: value.description,
          description_en: value.description_en,
          gems: value.costSelected == 'gems' ? value.cost * 1 : 0,
          promotion: value.quantity ? 'Y' : 'N',
          qty: value.quantity?Number(value.quantityLimits):0,
          monthly_period: nextMonthlyPeriod,
          reward: value.name,
          reward_en: value.name_en,
          rewards: value.names,
          // type: value.type,
          starton: format(value.duration[0], 'DD/MM/YYYY HH:mm'),
          endon: format(value.duration[1], 'DD/MM/YYYY HH:mm'),
          updateby: rootState.authen.user.email,
          updatetime: format(new Date(), 'YYYY-MM-DD HH:mm:ss')
        };
        
        if(country!="All Countries"){
          Object.assign(savedata, {country: country});
        }else{
          firebase.database().ref(`/rewards_company/${rootState.authen.user.company}/${value.key}/country`).remove();
        }

        let tag = [tag_value]
        if(tag_value == '0'){  // Gift Cards
          Object.assign(savedata, {type: 'OS', tag: tag, newtype: "Gift card"});
        }else if(tag_value == '1'){  // Team Building
          Object.assign(savedata, {type: 'OS', tag: tag, newtype: "Group Reward"});
        }else if(tag_value == '2'){  // Doing Good
          Object.assign(savedata, {type: 'OS', tag: tag, newtype: "Donation"});
        }else if(tag_value == '3'){  // Perks
          Object.assign(savedata, {type: 'IS', tag: tag, newtype: "Company Reward"});
        }else{
          Object.assign(savedata, {type: 'OS', tag: tag, newtype: "Company Reward"});
        }
        
        // if(value.type=="OS")
        // {
        // Object.assign(savedata, {newtype: "Gift card"});
        // }
        // if(value.quantity){
        //   Object.assign(data, {limit: value.quantityLimits});
        // }
      }
      if(approval_reward==true){
        Object.assign(savedata, {approval_reward: "Y"});
      }else{
        firebase.database().ref(`/rewards_company/${rootState.authen.user.company}/${value.key}/approval_reward`).remove();
      }
      const wasMonthly = !!data.monthly_period
      if(Number(data.qty) !== Number(value.qty) || wasMonthly !== isMonthly){
        savedata['used'] = 0
      }

      firebase.database().ref(`/rewards_company/${rootState.authen.user.company}/${value.key}`).update(savedata).then(() => {
        if (tmp_image.file.length > 0) {
          const imageName = sanitizeRewardFilename(tmp_image.file[0].name)
          firebase.storage().ref().child(`images/reward_company/${rootState.authen.user.company}/${value.key}/${tmp_image.filename}`).delete();
          firebase.storage().ref(`images/reward_company/${rootState.authen.user.company}/${value.key}/${imageName}`)
            .put(tmp_image.file[0]).then((snapshot) => {
              if (snapshot.state == 'success') {
                const update = {
                  filename: imageName,
                  filepath: `images/reward_company/${rootState.authen.user.company}/${value.key}/${imageName}`
                };
                firebase.database().ref(`rewards_company/${rootState.authen.user.company}/${value.key}`).update(update).then(() => {
                  /*save logs*/
                  dispatch('authen/addLogs', {
                    company: rootState.authen.user.company,
                    createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    id: value.key,
                    table: 'rewards_company',
                    status: 'edit',
                    user: rootState.authen.user.email
                  }, {root:true}).then(function() {
                    dispatch('patchRewardInCatalog', {
                      key: value.key,
                      partial: Object.assign({}, savedata, update),
                    })
                  });
                });
              }
            });
        } else {
          /*save logs*/
          dispatch('authen/addLogs', {
            company: rootState.authen.user.company,
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            id: value.key,
            table: 'rewards_company',
            status: 'edit',
            user: rootState.authen.user.email
          }, {root:true}).then(function() {
            dispatch('patchRewardInCatalog', { key: value.key, partial: savedata })
          });
        }
      });
    },
    async saveLinkedGemVariant({ rootState, state, dispatch }: any, payload: any) {
      const user = rootState.authen.user
      const sourceReward = payload && payload.sourceReward
      const masterRewardId = getMasterRewardId(sourceReward, sourceReward && sourceReward.key)
      const masterReward = state.rewardsMasterData[masterRewardId] || state.rewardsall_db[masterRewardId]
      const validation = validateLinkedGemVariant(sourceReward, masterReward, payload && payload.gems)

      if (!validation.valid) {
        throw new Error(validation.errors[0] || 'invalid_linked_gem_variant')
      }

      // payload.existingVariant was resolved from the page-load catalog snapshot
      // (rewards_catalog_raw is a one-shot read) — re-resolve against a fresh read
      // at save time so two admins can't both create a variant for the same
      // master, and so promotion/qty/used are preserved from live values.
      const freshCatalog = (await firebase.database().ref(`rewards_company/${user.company}`).once('value')).val() || {}
      const liveVariant = findLinkedGemVariant(freshCatalog, masterRewardId)
      const existingVariant = liveVariant || (payload && payload.existingVariant)

      const now = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
      const key = existingVariant && existingVariant.key
        ? existingVariant.key
        : firebase.database().ref(`rewards_company/${user.company}`).push().key

      if (!key) throw new Error('unable_to_create_variant_id')

      const variant = buildLinkedGemVariant({
        sourceReward,
        masterReward,
        masterRewardId,
        company: user.company,
        gems: payload.gems,
        actor: user.email,
        now,
      })

      if (existingVariant) {
        variant.createtime = existingVariant.createtime || now
        variant.promotion = existingVariant.promotion || 'N'
        variant.qty = Number(existingVariant.qty) || 0
        variant.used = Number(existingVariant.used) || 0
        variant.monthly_period = existingVariant.monthly_period || null
        if (existingVariant.approval_reward !== undefined) {
          variant.approval_reward = existingVariant.approval_reward
        }
      } else if (sourceReward.approval_reward !== undefined) {
        variant.approval_reward = sourceReward.approval_reward
      }

      await firebase.database().ref(`rewards_company/${user.company}/${key}`).update(variant)
      await dispatch('patchRewardInCatalog', { key, partial: variant })
      await dispatch('authen/addLogs', {
        company: user.company,
        createdate: now,
        id: key,
        table: 'rewards_company',
        status: existingVariant ? 'edit_linked_gem_variant' : 'add_linked_gem_variant',
        user: user.email,
        details: {
          master_reward_id: masterRewardId,
          gems: Number(payload.gems),
          validation_only: false,
        },
      }, { root: true })

      return { key, ...variant }
    },
    async getRewardMessage({commit,dispatch,state,rootState}:any, item:any){
      let bytes  = CryptoJS.AES.decrypt(item.code, 'HappilyReward');
      let originalText = bytes.toString(CryptoJS.enc.Utf8);
      let codeSplit = originalText.split("||")
      let arrData:Array<any> = [];
      let rewardmessage:any = {}
      let email = codeSplit[0]
      let keyId = codeSplit[0].replace(/\./g, "||")
      let reward_id = codeSplit[1]
      let stock_id = codeSplit[2]
      if(codeSplit[0]){
        var userData = await getByUser(codeSplit[0])//(await firebase.database().ref(`users/${keyId}`).once('value')).val()
      }
      const rewardData = (await firebase.database().ref(`rewards/${reward_id}`).once('value')).val()
      if(userData){
        const companyData =await getCompany(userData.company)//(await firebase.database().ref(`company/${userData.company}`).once('value')).val()
        firebase.auth().onAuthStateChanged(async function(user) {
          if(user){
            let _data = (await firebase.database().ref(`/stock_used/${reward_id}/${stock_id}`).once('value')).val()
            if((_data.send_to && _data.send_to == email) || (!_data.send_to && _data.email == email) && userData){
              rewardmessage.firstname = userData.firstname
              rewardmessage.company = companyData.name
              // rewardmessage.secreturl = _data.code_image
              rewardmessage.giftName = rewardData.reward_en
              const storageRef = firebase.storage().refFromURL(_data.code_image)
  
              firebase.storage().ref().child(storageRef.fullPath).getDownloadURL().then( (url) => {
                rewardmessage.secreturl = url
                arrData['data'] = rewardmessage
                commit('setRewardMessageData', arrData)
              }).catch(function (error) {
                  // rewardmessage.secreturl = "img/noimg.png";
              });
            }
          }else{
            console.warn('Reward message preview requires an authenticated session.')
          }
        });
      }
      
      
    },
    async setOldReward({commit,dispatch,state,rootState}:any, item:any){
      const keys = getNewRewardKeysForTab(state.newReward, item)
      if (!keys || keys.length === 0) {
        return
      }

      const company = rootState.authen.user.company
      const updates: any = {}
      keys.forEach((key: string) => {
        updates[`rewards_company/${company}/${key}/oldreward`] = true
      })

      await firebase.database().ref().update(updates)

      const patches = keys.map((key: string) => ({ key, partial: { oldreward: true } }))
      await dispatch('patchRewardsInCatalog', patches)

      keys.forEach((key: string) => {
        dispatch('authen/addLogs', {
          company,
          createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          id: key,
          table: 'rewards_company',
          status: 'read new reward',
          user: rootState.authen.user.email
        }, { root: true })
      })
    },
    // Bulk Update Actions
    async getGiftCardRewardsForBulkUpdate({ commit, rootState, state }: any) {
      // Get all gift card rewards (tag 0) for the company
      const rewards: any[] = [];
      
      try {
        const snapshot = await firebase.database()
          .ref(`rewards_company/${rootState.authen.user.company}`)
          .once('value');
        
        if (!snapshot.exists()) {
          return rewards;
        }
        
        snapshot.forEach((doc: any) => {
          const data = doc.val();
          
          // Only include gift cards (tag includes '0') - includes both enabled and disabled rewards
          if (data && data.tag && Array.isArray(data.tag) && data.tag.includes('0')) {
            // Check if reward has valid dates (not expired)
            if (data.endon) {
              try {
                const endParts = data.endon.split(" ");
                const endDateParts = endParts[0] ? endParts[0].split("/") : [];
                if (endDateParts.length === 3) {
                  const endDate = new Date(
                    parseInt(endDateParts[2]),
                    parseInt(endDateParts[1]) - 1,
                    parseInt(endDateParts[0])
                  );
                  if (endDate < new Date()) {
                    return; // Skip expired rewards
                  }
                }
              } catch (e) {
                // Skip rewards with invalid dates
                return;
              }
            }
            
            rewards.push({
              key: doc.key,
              ...data,
              reward_en: data.reward_en || data.reward || '',
              price: data.price || 0,
              coins: data.coins || 0,
              reward_currency: data.reward_currency,
              country: data.country
            });
          }
        });
        
        return rewards;
      } catch (error) {
        console.error('Error fetching gift card rewards for bulk update:', error);
        return rewards;
      }
    },
    async bulkUpdateCoinRates({ commit, rootState, dispatch }: any, payload: { rewards: any[], user: any,currency: string,new_rate: number }) {
      const { rewards, user,currency,new_rate } =  _.cloneDeep(payload);
      const updates: any = {};
      const currencyData: any = {
        [currency]: new_rate,
        updateby: user.email,
        updatetime: format(new Date(), 'YYYY-MM-DD HH:mm:ss')
      }
      //console.log('currencyData',currencyData);
      await firebase.database().ref(`company_currency_rates/${user.company}`).update(currencyData);

      
      // Prepare batch updates
      rewards.forEach((reward: any) => {
        if (reward.key && reward.newCoins !== undefined) {
          updates[`rewards_company/${user.company}/${reward.key}/coins`] = reward.newCoins;
          updates[`rewards_company/${user.company}/${reward.key}/updateby`] = user.email;
          updates[`rewards_company/${user.company}/${reward.key}/updatetime`] = format(new Date(), 'YYYY-MM-DD HH:mm:ss');
        }
      });
      
      if (Object.keys(updates).length === 0) {
        return;
      }
      
      // Execute batch update
      await firebase.database().ref().update(updates);
      
      // Log the bulk update action
      await dispatch('authen/addLogs', {
        company: user.company,
        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        id: 'bulk_coin_rate_update',
        table: 'rewards_company',
        status: 'bulk_update',
        user: user.email,
        details: {
          count: rewards.length,
          rewards: rewards.map((r: any) => ({
            key: r.key,
            oldCoins: r.coins,
            newCoins: r.newCoins
          }))
        }
      }, { root: true });
    },

    async loadGemExchangeConfig({ commit, rootState }: any) {
      const company = rootState.authen.user.company
      const snap = await firebase.database().ref(`company/${company}/gem_exchange`).once('value')
      const config = snap.val() || { enabled: false, tiers: [] }
      if (!Array.isArray(config.tiers)) config.tiers = []
      commit('setGemExchangeConfig', config)
      return config
    },

    async saveGemExchange({ commit, rootState, state, dispatch }: any, payload: {
      enabled: boolean,
      name: string,
      image: { filename: string, filepath: string, is_default?: boolean } | null,
      imageFile: any,
      useDefaultImage?: boolean,
      defaultImageUrl?: string,
      name_template: { en: string, th?: string },
      description_template: { en: string, th?: string },
      duration: any[],
      tiers: Array<{ reward_id?: string, gems: number, coins_yield: number, qty?: number, promotion?: 'Y' | 'N', isMonthly?: boolean }>,
      previousUpdatetime?: string
    }) {
      const user = rootState.authen.user
      const company = user.company
      const now = format(new Date(), 'YYYY-MM-DD HH:mm:ss')

      // Stale-check: bail if someone else edited concurrently
      const currentSnap = await firebase.database().ref(`company/${company}/gem_exchange/updatetime`).once('value')
      const serverTime = currentSnap.val()
      if (payload.previousUpdatetime && serverTime && serverTime !== payload.previousUpdatetime) {
        throw new Error('gem_exchange_stale')
      }

      // Resolve image. Precedence:
      //   1) admin uploaded a new file → upload and use it
      //   2) useDefaultImage + no existing default stored → fetch bundled asset, upload, mark as default
      //   3) otherwise keep existing payload.image reference
      let image: { filename: string, filepath: string, is_default?: boolean } | null = payload.image || null
      if (payload.imageFile) {
        const imageName = sanitizeRewardFilename(payload.imageFile.name)
        const filepath = `images/reward_company/${company}/gem_exchange/${imageName}`
        await firebase.storage().ref(filepath).put(payload.imageFile)
        image = { filename: imageName, filepath, is_default: false }
      } else if (payload.useDefaultImage && (!image || !image.filepath || !image.is_default)) {
        // Fetch bundled default and upload once per company
        if (payload.defaultImageUrl) {
          try {
            const res = await fetch(payload.defaultImageUrl)
            const blob = await res.blob()
            const filename = 'coin-gem-exchange.png'
            const filepath = `images/reward_company/${company}/gem_exchange/default-${filename}`
            await firebase.storage().ref(filepath).put(blob)
            image = { filename, filepath, is_default: true }
          } catch (e) {
            console.warn('[saveGemExchange] default image upload failed', e)
          }
        }
      }

      // Resolve per-language templates. Every language falls back to EN when empty.
      const nameTpl: any = {}
      const descTpl: any = {}
      const nameKeys = new Set([...Object.keys(payload.name_template || {}), 'en', 'th'])
      const descKeys = new Set([...Object.keys(payload.description_template || {}), 'en', 'th'])
      const nameEn = (payload.name_template && payload.name_template.en) || ''
      const descEn = (payload.description_template && payload.description_template.en) || ''
      nameKeys.forEach((k) => {
        nameTpl[k] = (payload.name_template && payload.name_template[k]) || nameEn
      })
      descKeys.forEach((k) => {
        descTpl[k] = (payload.description_template && payload.description_template[k]) || descEn
      })

      const fill = (tpl: string, gems: number, coins: number) => {
        if (!tpl) return ''
        return tpl
          .replace(/\{gems\}\s+gems\b/gi, `${gems} ${gems === 1 ? 'gem' : 'gems'}`)
          .replace(/\{gems\}\s+gem\b/gi, `${gems} ${gems === 1 ? 'gem' : 'gems'}`)
          .replace(/\{coins\}\s+coins\b/gi, `${coins} ${coins === 1 ? 'coin' : 'coins'}`)
          .replace(/\{coins\}\s+coin\b/gi, `${coins} ${coins === 1 ? 'coin' : 'coins'}`)
          .replace(/\{gems\}/g, String(gems))
          .replace(/\{coins\}/g, String(coins))
      }

      const starton = payload.duration && payload.duration[0]
        ? format(payload.duration[0], 'DD/MM/YYYY HH:mm') : ''
      const endon = payload.duration && payload.duration[1]
        ? format(payload.duration[1], 'DD/MM/YYYY HH:mm') : ''

      // Diff old tiers vs new
      const previous: any[] = (state.gemExchangeConfig && state.gemExchangeConfig.tiers) || []
      const previousById: any = {}
      previous.forEach((t: any) => { if (t.reward_id) previousById[t.reward_id] = t })

      const updates: any = {}
      const nextTiers: Array<{ reward_id: string, gems: number, coins_yield: number, promotion: 'Y' | 'N', qty: number, monthly_period: string | null }> = []
      const currentMonth = format(new Date(), 'YYYY-MM')

      // For each incoming tier: create if no id, update if existing
      payload.tiers.forEach((tier) => {
        const gems = Number(tier.gems) || 0
        const coins = Number(tier.coins_yield) || 0
        const tierQty = Number(tier.qty) || 0
        const capEnabled = tierQty > 0 && (tier.promotion === 'Y' || !tier.promotion)
        const isMonthly = !!tier.isMonthly && capEnabled
        let rewardId = tier.reward_id
        const isNew = !rewardId
        if (isNew) {
          rewardId = firebase.database().ref(`rewards_company/${company}`).push().key as string
        }

        const rewardsPerLang: any = {}
        const descriptionsPerLang: any = {}
        Object.keys(nameTpl).forEach((k) => { rewardsPerLang[k] = fill(nameTpl[k], gems, coins) })
        Object.keys(descTpl).forEach((k) => { descriptionsPerLang[k] = fill(descTpl[k], gems, coins) })

        const rewardDoc: any = {
          coins: 0,
          gems,
          company,
          rewards: rewardsPerLang,
          reward: rewardsPerLang.th || rewardsPerLang.en || '',
          reward_en: rewardsPerLang.en || '',
          descriptions: descriptionsPerLang,
          description: descriptionsPerLang.th || descriptionsPerLang.en || '',
          description_en: descriptionsPerLang.en || '',
          promotion: capEnabled ? 'Y' : 'N',
          qty: capEnabled ? tierQty : 0,
          monthly_period: isMonthly ? currentMonth : null,
          status: payload.enabled ? 'Y' : 'N',
          show: payload.enabled ? 'Y' : 'N',
          type: 'IS',
          tag: ['3'],
          newtype: 'Company Reward',
          starton,
          endon,
          updateby: user.email,
          updatetime: now,
          price: 0,
          exchange_coin_yield: coins,
          managed_by: 'gem_exchange',
          edit: 'N'
        }
        if (isNew) {
          rewardDoc.createtime = now
          rewardDoc.used = 0
        }
        if (image) {
          rewardDoc.filename = image.filename
          rewardDoc.filepath = image.filepath
        }

        updates[`rewards_company/${company}/${rewardId}`] = isNew
          ? rewardDoc
          : Object.assign({}, previousById[rewardId!] ? {} : {}, rewardDoc)

        // For updates we want a merge, not a replace, so write fields individually
        if (!isNew) {
          delete updates[`rewards_company/${company}/${rewardId}`]
          Object.keys(rewardDoc).forEach((k) => {
            updates[`rewards_company/${company}/${rewardId}/${k}`] = rewardDoc[k]
          })
          // Reset `used` when the cap changes or monthly mode flips.
          const prevTier = previousById[rewardId!] || {}
          const prevQty = Number(prevTier.qty) || 0
          const prevWasMonthly = !!prevTier.monthly_period
          const newQty = capEnabled ? tierQty : 0
          if (prevQty !== newQty || prevWasMonthly !== isMonthly) {
            updates[`rewards_company/${company}/${rewardId}/used`] = 0
          }
        }

        nextTiers.push({
          reward_id: rewardId!,
          gems,
          coins_yield: coins,
          promotion: capEnabled ? 'Y' : 'N',
          qty: capEnabled ? tierQty : 0,
          monthly_period: isMonthly ? currentMonth : null
        })
      })

      // Soft-delete tiers that were removed from the config
      const keptIds = new Set(nextTiers.map(t => t.reward_id))
      previous.forEach((t: any) => {
        if (!t.reward_id || keptIds.has(t.reward_id)) return
        updates[`rewards_company/${company}/${t.reward_id}/status`] = 'N'
        updates[`rewards_company/${company}/${t.reward_id}/show`] = 'N'
        updates[`rewards_company/${company}/${t.reward_id}/managed_by`] = 'gem_exchange_archived'
        updates[`rewards_company/${company}/${t.reward_id}/updateby`] = user.email
        updates[`rewards_company/${company}/${t.reward_id}/updatetime`] = now
      })

      // Write the company-level config
      const configDoc: any = {
        enabled: payload.enabled,
        name: payload.name || '',
        image: image || null,
        name_template: nameTpl,
        description_template: descTpl,
        duration: [starton, endon],
        tiers: nextTiers,
        updateby: user.email,
        updatetime: now
      }
      updates[`company/${company}/gem_exchange`] = configDoc

      await firebase.database().ref().update(updates)

      await dispatch('authen/addLogs', {
        company,
        createdate: now,
        id: 'gem_exchange_save',
        table: 'rewards_company',
        status: 'bulk_update',
        user: user.email,
        details: {
          enabled: payload.enabled,
          tiers: nextTiers.length,
          removed: previous.length - nextTiers.filter(t => previousById[t.reward_id]).length
        }
      }, { root: true })

      commit('setGemExchangeConfig', configDoc)
      await dispatch('getRewards', user)
      return configDoc
    }
  },
  getters: {
    rewards: (state: any) => {
      return state.rewards
    },
    rewardsCatalogRaw: (state: any) => {
      return state.rewards_catalog_raw || {}
    },
    redeemed: (state: any) => {
      return state.redeemed
    },
    countrewards: (state: any) => {
      return state.countrewards
    },
    inputSearch: (state: any) => {
      return state.inputSearch
    },
    list_month: (state: any) => {
      return state.list_month
    },
    start_month: (state: any) => {
      return state.start_month
    },
    loadmore: (state: any) => {
      return state.loadmore
    },
    showTextLoading: (state: any) => {
      return state.showTextLoading
    },
    rewardActivityLoading: (state: any) => {
      return state.rewardActivityLoading
    },
    rewardActivityRefreshing: (state: any) => {
      return state.rewardActivityRefreshing
    },
    rewardActivityError: (state: any) => {
      return state.rewardActivityError
    },
    rewardsemptytext: (state: any) => {
      return state.rewardsemptytext
    },
    engonly: (state: any) => {
      return state.engonly
    },
    rewardMessageData: (state: any) => {
      return state.rewardMessageData
    },
    processingRedeemed: (state: any) => {
      return state.processingRedeemed
    },
    country: (state: any) => {
      return state.country
    },
    memberCountries: (state: any) => {
      return state.memberCountries
    },
    catalogCountries: (state: any) => {
      return state.catalogCountries
    },
    selectedCountryFilter: (state: any) => {
      return state.selectedCountryFilter
    },
    dataChart: (state: any) => {
      return state.dataChart
    },
    companySymbol : (state:any) => {
      return state.companySymbol
    },
    allSymbol : (state:any) => {
      return state.allSymbol
    },
    tagMaster : (state:any) => {
      return state.tagMaster
    },
    rewardsMasterData : (state:any) => {
      return state.rewardsMasterData
    },
    language : (state:any) => {
      return state.language
    },
    countNewReward : (state:any) => {
      return state.countNewReward
    },
    gemExchangeConfig : (state:any) => {
      return state.gemExchangeConfig
    }
  }
}
